module.exports = __webpack_public_path__ + "img/111.dc5fc173.svg";